module.exports = {
      id: "arrow_outward-usage",
      viewBox: "0 0 10 9",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#arrow_outward",
      toString: function () {
        return this.url;
      }
    }